import api from '../../config/api_config';

export const logisticsApi = {
    // Public logistics company endpoints
    getCompanies: (params) => api.get('/logistics-companies/', { params }),
    getCompanyById: (id) => api.get(`/logistics-companies/${id}/`),
    getCompanyRates: (id) => api.get(`/logistics-companies/${id}/get_rates/`),
    
    // Logistics company registration
    registerCompany: (data) => api.post('/logistics-companies/', data, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),
    
    // Current logistics company profile (authenticated)
    getMyCompany: () => api.get('/logistics-companies/my_company/'),
    updateMyCompany: (data) => api.patch('/logistics-companies/update_my_company/', data, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),
    getDashboard: () => api.get('/logistics-companies/dashboard/'),
    
    // Rates management
    getRates: (params) => api.get('/logistics-rates/', { params }),
    createRate: (data) => api.post('/logistics-rates/', data),
    updateRate: (id, data) => api.patch(`/logistics-rates/${id}/`, data),
    deleteRate: (id) => api.delete(`/logistics-rates/${id}/`),
    
    // Vehicles management
    getVehicles: () => api.get('/logistics-vehicles/'),
    addVehicle: (data) => api.post('/logistics-vehicles/', data),
    updateVehicle: (id, data) => api.patch(`/logistics-vehicles/${id}/`, data),
    deleteVehicle: (id) => api.delete(`/logistics-vehicles/${id}/`),
    
    // Shipments (for logistics companies)
    getShipments: (params) => api.get('/shipments/', { params }),
    getShipmentById: (id) => api.get(`/shipments/${id}/`),
    updateShipmentStatus: (id, data) => api.post(`/shipments/${id}/update_status/`, data),
    trackShipment: (id) => api.get(`/shipments/${id}/track/`),
};

export const shippingApi = {
    // Shipping rate quotes
    getQuotes: (data) => api.post('/shipping-rates/get_quotes/', data),
    
    // Shipment tracking for customers
    getShipmentTracking: (shipmentId) => api.get(`/shipments/${shipmentId}/tracking/`),
    
    // User shipping addresses
    getAddresses: () => api.get('/shipping-addresses/'),
    addAddress: (data) => api.post('/shipping-addresses/', data),
    updateAddress: (id, data) => api.patch(`/shipping-addresses/${id}/`, data),
    deleteAddress: (id) => api.delete(`/shipping-addresses/${id}/`),
    setDefaultAddress: (id) => api.post(`/shipping-addresses/${id}/set_default/`),
};
